
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { resolve } from 'path';
import { auth, firestore } from '../resources/firebase';

const actions = {
	getOrganization({}, data){
        return new Promise((resolve, reject) => {
            const orgRef = doc(firestore, 'organizations', data.orgId)
            getDoc(orgRef).then((organizationSnapshot) => {
                const orgData = organizationSnapshot.data()
                return resolve(orgData)
            }).catch((error) => {
                return reject(error)
            })
        })
    }
};

export default actions;
